import { Component, inject, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ConfigOptions } from '@multimediasrl/emed-ui-config';
import { SharedModuleOptions, EmedTraduzione, SharedCssService, CustomTheme, IMyCssService, GestioneCancellazioneSelector, SetCancella, SetDisplayCancellaDialog, SetDisplayForm } from '@multimediasrl/emed-ui-shared';

import { TranslateService } from '@ngx-translate/core';

import { Store } from '@ngxs/store';

import { Subscription } from 'rxjs';

import { OidcSecurityService } from 'angular-auth-oidc-client';
import { jwtDecode } from 'jwt-decode';

import { environment } from '../../../environments/environment';
import { CognitoSelector } from '../../modules/dispatcher/state/selectors/cognito-selector';

@Component({
  selector: 'app-emed-home',
  templateUrl: './emed-home.component.html',
  styleUrls: ['./emed-home.component.scss'],
  standalone: false
})
export class EmedHomeComponent implements OnInit, OnDestroy {
  private subArray: Subscription[] = [];

  public isAuthenticated = false;
  public idToken: any;

  public theme = 'theme-light';

  private sharedCssService: SharedCssService;

  public lingue: EmedTraduzione[] = [];
  public linguaSelezionata: EmedTraduzione;

  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly router = inject(Router);

    private displayCancellaDialogComponents: string[] = [];

    public displayCancellaDialog: boolean;

  constructor(
    private store: Store,
    public configOptions: ConfigOptions,
    private cognitoSelector: CognitoSelector,
    private translateService: TranslateService,
    private sharedModuleOptions: SharedModuleOptions,
    private gestioneCancellazioneSelector: GestioneCancellazioneSelector,
    @Inject('IMyCssService') iMyCssService: IMyCssService,
  ) {
    this.sharedCssService = iMyCssService as unknown as SharedCssService;
  }

  ngOnDestroy(): void {
    this.subArray.forEach((x) => x.unsubscribe());
  }

  ngOnInit(): void {
    this.subArray.push(
      this.cognitoSelector.isAuthenticated$.subscribe((data) => {
        this.isAuthenticated = data;
      })
    );

    this.subArray.push(
      this.cognitoSelector.idToken$.subscribe((data) => {
        try {
          this.idToken = jwtDecode(data);
        } catch (Error) {
          this.idToken = null;
        }
      })
    );

        this.subArray.push(
      this.gestioneCancellazioneSelector.getDisplayCancellaDialog().subscribe((data) => {
        this.displayCancellaDialogComponents = data;
        if (data.length > 0) {
          this.displayCancellaDialog = true;
          return;
        }

        this.displayCancellaDialog = false;
      })
    );

    const italiano = new EmedTraduzione();
    italiano.id = 1;
    italiano.descrizione = 'italiano';
    italiano.sigla = 'it';
    italiano.path = 'assets/emed-ui-shared/images/flags/it.svg';

    const inglese = new EmedTraduzione();
    inglese.id = 2;
    inglese.descrizione = 'inglese';
    inglese.sigla = 'en';
    inglese.path = 'assets/emed-ui-shared/images/flags/gb.svg';

    const tedesco = new EmedTraduzione();
    tedesco.id = 3;
    tedesco.descrizione = 'tedesco';
    tedesco.sigla = 'de';
    tedesco.path = 'assets/emed-ui-shared/images/flags/de.svg';

    this.lingue.push(italiano, inglese, tedesco);

    const localStorageSiglaTraduzione = localStorage.getItem(this.sharedModuleOptions.localStorageID + '-siglaTraduzione');

    const index = this.lingue.findIndex((t) => t.sigla === localStorageSiglaTraduzione);

    this.linguaSelezionata = index >= 0 ? this.lingue[index] : italiano;
  }

  public toggleDarkMode(): void {
    const body = document.querySelector('body');
    const html = document.querySelector('html');

    const theme = localStorage.getItem(environment.localStorageID + '-app-theme');

    if (theme == CustomTheme.LIGHT) {
      body.className = 'theme-dark';
      html.className = 'my-app-dark';
      this.sharedCssService.setCssStyle('theme-dark');

      localStorage.setItem(environment.localStorageID + '-app-theme', CustomTheme.DARK);

      return;
    }

    if (theme == CustomTheme.DARK) {
      body.className = 'theme-light';
      html.className = '';
      this.sharedCssService.setCssStyle('theme-light');

      localStorage.setItem(environment.localStorageID + '-app-theme', CustomTheme.LIGHT);

      return;
    }
  }

  public changeIcon() {
    const theme = localStorage.getItem(environment.localStorageID + '-app-theme');

    if (theme == CustomTheme.LIGHT) {
      return { pi: true, 'pi-moon': true };
    }

    if (theme == CustomTheme.DARK) {
      return { pi: true, 'pi-sun': true };
    }

    return '';
  }

  public changeTraduzione(traduzione: EmedTraduzione): void {
    localStorage.setItem(this.sharedModuleOptions.localStorageID + '-siglaTraduzione', traduzione.sigla);
    this.translateService.use(traduzione.sigla);
  }

  login() {
    this.oidcSecurityService.authorize();
  }

  logout() {
    this.oidcSecurityService
      .logoff(undefined, {
        customParams: {
          client_id: environment.clientId,
          logout_uri: environment.logoutUrl
        }
      })
      .subscribe((result) => console.log(result));
  }

    public setCancella(event: boolean): void {
    // !! displayCancellaDialogComponents.length dovrebbe essere sempre == 1
    if (this.displayCancellaDialogComponents.length > 1) return;

    this.displayCancellaDialogComponents.forEach((element) => {
      this.store.dispatch(new SetCancella(element, event));
      this.store.dispatch(new SetDisplayCancellaDialog(element, false));
    });

    this.store.dispatch(new SetDisplayForm(false));
  }
}
